// Holds the host entered during ASV onboarding until the user has logged in
const asvOnboardingHostStorageKey = 'asvOnboardingHost' as const;

export function getAsvOnboardingHost(): string | null {
  return localStorage.getItem(asvOnboardingHostStorageKey);
}

export function setAsvOnboardingHost(host: string | null) {
  if (host) {
    localStorage.setItem(asvOnboardingHostStorageKey, host);
  } else {
    localStorage.removeItem(asvOnboardingHostStorageKey);
  }
}
